import { useEffect, useState } from "react";
import { NAV } from "@/data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (!target) return;
    if (window.__lenis) window.__lenis.scrollTo(target, { offset: -60 });
    else target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#f5f3ef]/80 backdrop-blur-md border-b border-[rgba(28,27,26,0.08)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          onClick={(e) => go(e, "#top")}
          className="font-display text-lg md:text-xl font-bold tracking-tight hover:text-[#e24a29] transition-colors"
        >
          Aditya Rajawat<span className="text-[#e24a29]">.</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              onClick={(e) => go(e, n.href)}
              className="text-sm font-medium text-[#57534e] hover:text-[#1c1b1a] relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#e24a29] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="header-cta"
          onClick={(e) => go(e, "#contact")}
          className="text-xs md:text-sm font-semibold px-4 md:px-5 py-2 rounded-full border border-[#1c1b1a] hover:bg-[#1c1b1a] hover:text-[#f5f3ef] transition-colors duration-300"
        >
          Let&apos;s talk
        </a>
      </div>
    </header>
  );
};
